import { render, staticRenderFns } from "./Peter.vue?vue&type=template&id=7353633d&scoped=true&"
import script from "./Peter.vue?vue&type=script&lang=js&"
export * from "./Peter.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7353633d",
  null
  ,true
)

export default component.exports